enum EVendorPartnerProgramLevel {
  AUTHORIZED = 'authorized',
  FOCUSED = 'focused',
  KEY = 'key',
  STRATEGIC = 'strategic',
}

export default EVendorPartnerProgramLevel;
